import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@tcc/crate';
import styles from './LinkCard.css';

function LinkCard({ icon, isVisible, text, onClick }) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={styles.card}
      data-test-id={`dmb-link-card-${text}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <Icon glyph={icon} />
      <h3>{text}</h3>
      <Icon className={styles.arrow} glyph={Icon.set.ARROW_RIGHT} />
    </div>
  );
}

LinkCard.propTypes = {
  icon: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default LinkCard;
